import { useCallback, useState } from 'react';

const useElementBoundingClientRect = <T extends HTMLElement>(): [
  DOMRect | undefined,
  (element: T | null) => void,
] => {
  const [rect, setRect] = useState<DOMRect>();

  const elementRef = useCallback((element: T | null) => {
    if (element !== null) {
      setRect(element.getBoundingClientRect());
    }
  }, []);

  return [rect, elementRef];
};

export default useElementBoundingClientRect;
